import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { DriverPresenceService } from './shared/driver-presence.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastContainerDirective, NgxSpinnerComponent],
  templateUrl: './app.component.html',
  styles: [':host { display: block; min-height: 100vh; }'],
})
export class AppComponent implements AfterViewInit {
  @ViewChild(ToastContainerDirective, { static: true })
  toastContainer!: ToastContainerDirective;

  constructor(
    private toastr: ToastrService,
    _presence: DriverPresenceService
  ) {}

  ngAfterViewInit(): void {
    this.toastr.overlayContainer = this.toastContainer;
  }
}
